if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        // Klaviyo notify me butonu ise sepete ekleme işlemini yapma
        if (this.submitButton.classList.contains('klaviyo-bis-trigger')) {
          return;
        }
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart && this.cart?.getSectionsToRender) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if(this.cart.renderContents){
                this.cart.renderContents(response);
              }
            }

            // Sepet sayacını güvenilir şekilde güncelle
            // (cart-icon-bubble ID'si cart-icon-bubble-x olarak değiştirildiği için
            //  section rendering ile güncelleme başarısız oluyor, bu yüzden /cart.js ile güncelliyoruz)
            fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
              .then(r => r.json())
              .then(cart => {
                const count = cart.item_count || 0;
                document.querySelectorAll('.cart-count-bubble').forEach(bubble => {
                  bubble.style.display = count > 0 ? 'block' : 'none';
                  const vis = bubble.querySelector('[aria-hidden="true"]');
                  if (vis) vis.textContent = String(count);
                  const sr = bubble.querySelector('.visually-hidden');
                  if (sr) sr.textContent = count + ' items';
                });
                ['cart-icon-bubble', 'cart-icon-bubble-x'].forEach(id => {
                  const anchor = document.getElementById(id);
                  if (!anchor) return;
                  let bubble = anchor.querySelector('.cart-count-bubble');
                  if (!bubble) {
                    bubble = document.createElement('div');
                    bubble.className = 'cart-count-bubble desktop-cart-count-bubble';
                    bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
                    anchor.appendChild(bubble);
                  }
                  bubble.style.display = count > 0 ? 'block' : 'none';
                  const vis = bubble.querySelector('[aria-hidden="true"]');
                  if (vis) vis.textContent = String(count);
                  const sr = bubble.querySelector('.visually-hidden');
                  if (sr) sr.textContent = count + ' items';
                });
              })
              .catch(() => {});
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('nonedisabled');
          this.submitButton.style.removeProperty('display');
          const currentSpan = this.submitButton.querySelector('span');
          if (currentSpan) {
            this.submitButtonText = currentSpan;
            currentSpan.textContent = window.variantStrings.addToCart;
          } else {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
